module.exports = __webpack_public_path__ + "static/iOS-c97c0ba38984c0075d0215e295798de5.png";